export default __webpack_public_path__ + "static/media/1b9015c67c57a06e.096c088447f8c876733cfba5d4184e63.svg";